import _objectDestructuringEmpty from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
import _extends from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
export default function _uid(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5L19 18M19 5L6 18",
    stroke: "#AFAFAF",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
_uid.displayName = "HeaderRight";